function setUserDefaultMes(type) {
    const key = "zutaMesType";
  
    if (type !== undefined) {
      // If type is provided, set it in localStorage
      localStorage.setItem(key, type);
    } else {
      // If type is not provided, retrieve the value from localStorage
      const existingValue = localStorage.getItem(key);
  
      if (existingValue === null) {
        // If the value does not exist in localStorage, set key as "SI" then return "SI"
        localStorage.setItem(key, "SI");
        return "SI";
      } else {
        // If the value exists, return the existing value
        return existingValue;
      }
    }
  }
  
  export default setUserDefaultMes;
  